const castToNumber = data => {
    let parse;
    if (~data.indexOf('.')) {
        parse = Number.parseFloat(data);
    } else {
        parse = Number.parseInt(data);
    }
    if (Number.isNaN(parse)) {
        return data;
    }
    return parse;
};

export {castToNumber};
